// extracted by mini-css-extract-plugin
export var alphaMinimal = ".1";
export var alphaUltraLight = ".2";
export var fontSizeSmall = ".8em";